import React from 'react';
import { initialAdControlProviderState } from './reducer';
export const AdControlContext = /*#__PURE__*/React.createContext({
  state: {
    ...initialAdControlProviderState
  },
  modalPropsRef: undefined,
  dispatch: () => {},
  onEvents: () => {},
  shouldShowDismissFlag: true
});